import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';



const LoginPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { setUser } = useAuth(); 

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
    await axios.post('https://metallpererabotka.ru/api/token/', {
        email,
        password
    }, {
        withCredentials: true
    });

    const res = await axios.get('https://metallpererabotka.ru/api/me/', {
        withCredentials: true
    });

    setUser(res.data); // 🟢 глобально обновляем user

    navigate('/');
    } catch (err) {
    setError('Неверный email или пароль');
    }

  };

  return (
    <div className="container">
    <div className="auth-form">
      <h2>Вход</h2>
      <form onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        /><br/>
        <input
          type="password"
          placeholder="Пароль"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        /><br/>
        <button type="submit">Войти</button>
        {error && <p style={{ color: 'black' }}>{error}</p>}
      </form>
      </div>
    </div>
  );
};

export default LoginPage;
